/** @file Projects browser filter: trash vs active, name or id search, sort by date or name. */
import type { ProjectListItem } from '../../api/apiTypes';

/** How the projects grid is narrowed and ordered. */
export interface ProjectFilter {
  query: string;
  sort: 'updated' | 'name';
  trash: boolean;
}

const ORDER: Record<ProjectFilter['sort'], (a: ProjectListItem, b: ProjectListItem) => number> = {
  updated: (a, b) => b.updatedAt.localeCompare(a.updatedAt),
  name: (a, b) => a.name.localeCompare(b.name, 'en'),
};

const BY_TRASH_DATE = (a: ProjectListItem, b: ProjectListItem): number => (b.trashedAt ?? '').localeCompare(a.trashedAt ?? '');

/** Returns a new array; `items` is left untouched. */
export function filterProjects(items: readonly ProjectListItem[], filter: ProjectFilter): ProjectListItem[] {
  const order = filter.trash && filter.sort === 'updated' ? BY_TRASH_DATE : ORDER[filter.sort];
  const query = filter.query.trim().toLowerCase();
  return items
    .filter((p) => (p.trashedAt !== null) === filter.trash && (p.name.toLowerCase().includes(query) || p.id.toLowerCase() === query))
    .sort(order);
}
